import { render, staticRenderFns } from "./VaimoRelatedProductCard.vue?vue&type=template&id=4a8023a0&scoped=true&"
import script from "./VaimoRelatedProductCard.vue?vue&type=script&lang=ts&"
export * from "./VaimoRelatedProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoRelatedProductCard.vue?vue&type=style&index=0&id=4a8023a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8023a0",
  null
  
)

export default component.exports